import { Pipe, PipeTransform } from "@angular/core";
import { IIdentifier } from "@comunicare/comunicare-interfaces";

@Pipe({
  name: "findIdentifierBySystem",
})
export class FindIdentifierBySystemPipe implements PipeTransform {
  transform(identifier: IIdentifier[], system: string): IIdentifier {
    return identifier.find((i) => i.system === system);
  }
}
